import { icon } from '@carvana/ds-styles';
import { Check } from 'lucide-react';
import { ToastActions, type ToastAction } from './types';

type OwnProps = {
  action: ToastAction;
};

export default function TradeAppliedToastContent({ action }: OwnProps) {
  const isAdding = action === ToastActions.add;
  const text = isAdding
    ? 'Pricing includes trade-in'
    : 'Trade-in removed from pricing';

  return (
    <div
      className="flex w-auto items-center justify-between gap-md"
      data-testid={`trade-applied-toast-${action}`}
    >
      <Check color={icon.strong} />
      <span className="text-text-strong t-heading-sm">{text}</span>
    </div>
  );
}
